import {
  actions,
  getProductsAsync,
  getProductsDatatableAsync,
  createProductAsync,
  editProductAsync,
  getProductByIdAsync,
  getProductsByProductGroupIdAsync,
} from './slices';

export const ProductsActions = {
  ...actions,
  getProductsAsync,
  getProductsDatatableAsync,
  createProductAsync,
  editProductAsync,
  getProductByIdAsync,
  getProductsByProductGroupIdAsync,
};
